export const isLdFlagInABTest = (ldFlagName, togglesToDatalayerValue) => {
  const list = togglesToDatalayerValue?.split(',')
  if (!list && !list?.length) return false

  return list.map(i => i.trim()).includes(ldFlagName)
}
